module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-active@3x-74af2ed7.svg";